import { gql } from '@apollo/client';

export const UPLOAD_FILE = gql`
  mutation UploadFile($input: UploadFileInput!) {
    uploadFile(input: $input) {
      parentId
      key
      url
      type
    }
  }
`;
